import { EstadoSolucion } from '@/shared/model/enumerations/estado-solucion.model';
import { EstadoSolicitud } from '@/shared/model/enumerations/estado-solicitud.model';
import { TipoSolucion } from '@/shared/model/enumerations/tipo-solucion.model';
import { TipoReglaFiltro } from '@/shared/model/enumerations/tipo-regla-filtro.model';
import { TipoAcceso } from '@/shared/model/enumerations/tipo-acceso.model';
import { EstadoBeca } from '@/shared/model/enumerations/estado-beca.model';
import { EstadoMovimientoBeca } from '@/shared/model/enumerations/estado-movimiento-beca.model';
import { EstadoDocumentoFormalizacion } from '@/shared/model/enumerations/estado-documentos-formalizacion.model';
import { TipoComentario } from './enumerations/tipo-comentario.model';
import { Area } from '@/shared/model/enumerations/area';
import { Moneda } from './enumerations/moneda';
import { EstadoFormalizacion } from './enumerations/estado-formalizacion.model';
import { TipoComision } from './enumerations/tipo-comision.model';

export interface IFiltroPropiedad {
  path?: string | null;
  nombre?: string | null;
  propiedad?: string | null;
  valor?: string | null;
  tipoReglaFiltro?: TipoReglaFiltro | null;
  filtroValores?: string[] | null;
}

export class FiltroPropiedad implements IFiltroPropiedad {
  constructor(
    public path?: string | null,
    public nombre?: string | null,
    public propiedad?: string | null,
    public valor?: string | null,
    public tipoReglaFiltro?: TipoReglaFiltro | null,
    public filtroValores?: string[] | null
  ) {}
}

export interface IFiltro {
  solicitudId?: string | null;
  solucionId?: string | null;
  cvuSolicitante?: string | null;
  curpSolicitante?: string | null;
  estadoSolucion?: EstadoSolucion | null;
  estadosSolicitud?: EstadoSolicitud[] | null;
  estadosFormalizacion?: EstadoFormalizacion[] | null;
  tiposDeAcceso?: TipoAcceso[] | null;
  usuario?: string | null;
  checkbox?: boolean;
  idsSolicitud?: string[];
  solucionVisible?: boolean | null;
  tipoSolicitud?: string;
  idsSolucion?: [string];
  rol?: string;
  estadoSolicitud?: EstadoSolicitud;
  claveArea?: string;
  propiedades?: IFiltroPropiedad[];
  esReconsideracion?: boolean;
  idInstitucion?: string;
  idDependencia?: string;
  idSubDependencia?: string;
  idDepartamento?: string;
  claveInstitucion?: string;
  clavePrograma?: string;
  claveProgramaLike?: string;
  noEstadosSolicitud?: EstadoSolicitud[] | null;
  procesoSolucion?: EstadoSolicitud;
  id?: string | null;
  clave?: string | null;
  tipoMovimientoBecaId?: string | null;
  estadoConvenioFirmado?: EstadoDocumentoFormalizacion;
  anioSolucion?: number;
  claveMovimiento?: string;
  tiposComentario?: TipoComentario[];
  incluye?: string;
  idInstitucionBeca?: string;
  cvuBeneficiario?: string;
  formalizacionApeiron?: boolean;
  curpHijo?: string;
  tipoComision?: TipoComision;
  anioNumero?: number;
  cvuInvestigadorMovimiento?: string;
  indicadorTipoSolucionBecasNacionales?: string;
  claveProgramaBecasYApoyos?: string;
  cvuUsuario?: string;
}

export class Filtro implements IFiltro {
  constructor(
    public solicitudId?: string | null,
    public solucionId?: string | null,
    public cvuSolicitante?: string | null,
    public curpSolicitante?: string | null,
    public estadoSolucion?: EstadoSolucion | null,
    public estadosSolicitud?: EstadoSolicitud[] | null,
    public estadosFormalizacion?: EstadoFormalizacion[] | null,
    public tiposDeAcceso?: TipoAcceso[] | null,
    public usuario?: string | null,
    public checkBoxSelected?: boolean | null,
    public idsSolicitud?: string[],
    public solucionVisible?: boolean,
    public tipoSolicitud?: string,
    public tipoSolucion?: TipoSolucion | null,
    public idsSolucion?: [string],
    public estadoSolicitud?: EstadoSolicitud,
    public claveArea?: string,
    public propiedades?: IFiltroPropiedad[],
    public tiposSolucion?: TipoSolucion[],
    public idInstitucion?: string,
    public idDependencia?: string,
    public idSubDependencia?: string,
    public idDepartamento?: string,
    public claveInstitucion?: string,
    public nombreInstitucionNacional?: string,
    public nombreProgramaNacional?: string,
    public claveProgramaNacional?: string,
    public nombresSolicitanteLike?: string,
    public nombreSolicitante?: string,
    public apellidoPaternoSolicitante?: string,
    public apellidoMaternoSolicitante?: string,
    public becaLiberada?: string,
    public estadoConvenioFirmado?: EstadoDocumentoFormalizacion,
    public anioSolucion?: number,
    public claveMovimiento?: string,
    public tiposComentario?: TipoComentario[],
    public clavePrograma?: string,
    public claveProgramaLike?: string,
    public idsSoluciones?: string[],
    public nombreInstitucionExtranjero?: string,
    public nombreProgramaExtranjero?: string,
    public incluye?: string,
    public idInstitucionBeca?: string,
    public cvuBeneficiario?: string,
    public formalizacionApeiron?: boolean,
    public curpHijo?: string,
    public anioNumero?: number,
    public cvuInvestigadorMovimiento?: string,
    public indicadorTipoSolucionBecasNacionales?: string,
    public procesoSolucion?: EstadoSolicitud,
    public claveProgramaBecasYApoyos?: string,
    public tipoComision?: TipoComision,
    public cvuUsuario?: string
  ) {
    this.estadosSolicitud = this.estadosSolicitud ? this.estadosSolicitud : [];
    this.estadosFormalizacion = this.estadosFormalizacion ? this.estadosFormalizacion : [];
    this.tiposDeAcceso = this.tiposDeAcceso ? this.tiposDeAcceso : [];
    this.propiedades = this.propiedades ? this.propiedades : [];
  }
}
export class FiltroBeca implements IFiltro {
  constructor(
    public solicitudId?: string | null,
    public solicitudRizomaId?: string | null,
    public solucionId?: string | null,
    public estadoBeca?: EstadoBeca | null,
    public estadosBeca?: EstadoBeca[] | null,
    public curpBecario?: string | null,
    public cvuBecario?: string | null,
    public numeroApoyo?: string | null,
    public nombreBecario?: string | null,
    public apellidoPaternoBecario?: string | null,
    public apellidoMaternoBecario?: string | null,
    public claveInstitucionNacional?: string | null,
    public nombreInstitucionNacional?: string | null,
    public claveProgramaNacional?: string | null,
    public nombreProgramaNacional?: string | null,
    public claveSedeNacional?: string | null,
    public nombreSedeNacional?: string | null,
    public claveGradoNacional?: string | null,
    public nombreGradoNacional?: string | null,
    public tipoSolucion?: string | null,
    public tipoPrograma?: string | null,
    public orientacion?: string | null,
    public modalidad?: string | null,
    public bitacoraLiberacionBecasId?: string | null,
    public area?: Area | null,
    public paisClaves?: string[],
    public moneda?: Moneda | null,
    public clavePais?: string,
    public institucionId?: string,
    public isDivisa?: boolean,
    public isColegiatura?: boolean,
    public isInstitucion?: boolean,
    public estatusCuenta?: EstadoSolicitud | null,
    public cvuBecarios?: string[],
    public isCurso?: boolean
  ) {
    this.estadosBeca = this.estadosBeca ? this.estadosBeca : [];
  }
}

export class FiltroMotivoMovimientoBeca implements IFiltro {
  constructor(public id?: string | null, public clave?: string | null, public tipoMovimientoBecaId?: string | null) {}
}

export class FiltroMovimientoBeca implements IFiltro {
  constructor(
    public id?: string | null,
    public estadoActual?: EstadoMovimientoBeca | null,
    public becaId?: string | null,
    public tipoMovimientoBecaId?: string | null,
    public motivoMovimientoBecaId?: string | null,
    public cvuBecario?: string | null,
    public nombreBecario?: string | null,
    public apellidoPaternoBecario?: string | null,
    public apellidoMaternoBecario?: string | null,
    public estadosMovimientoBeca?: EstadoMovimientoBeca[] | null,
    public programaClave?: string[] | null,
    public institucionClave?: string[] | null,
    public sedeClave?: string[] | null,
    public tipoMovimientoBecaClave?: string | null,
    public tipoSolucion?: string,
    public solucionId?: string | null,
    public fechaInicio?: string | null,
    public fechaFin?: string | null,
    public origenMovimiento?: string | null
  ) {}
}

export class FiltroCartaConclusion implements IFiltro {
  constructor(
    public id?: string | null,
    public tipo?: string | null,
    public estadoActual?: EstadoSolicitud | null,
    public becaId?: string | null,
    public cvuBecario?: string | null,
    public numeroApoyo?: string | null,
    public nombreBecario?: string | null,
    public solucionSolicitudId?: string | null
  ) {}
}

export class FiltroSnp implements IFiltro {
  constructor(
    public solucionId?: string | null,
    public estadoSolucion?: EstadoSolucion | null,
    public tiposSolucion?: TipoSolucion[],
    public tipoSolucion?: TipoSolucion | null,
    public estadosSolicitud?: EstadoSolicitud[] | null,
    public tipoComisionSnp?: TipoComision | null,
    public claveAreaSnp?: string | null,
    public claveProgramaSnp?: string | null,
    public nombreProgramaSnp?: string | null,
    public resultadoDictamenEvaluacionDictaminadora?: string | null,
    public resultadoDictamenFormalizacionDictaminadora?: string | null,
    public resultadoDictamenEvaluacionReconsideracion?: string | null,
    public resultadoDictamenFormalizacionReconsideracion?: string | null,
    public programaLike?: string | null
  ) {}

  static fromObject(item: FiltroSnp): FiltroSnp {
    const opcion = new FiltroSnp();
    for (const [key, value] of Object.entries(item)) {
      opcion[key] = value;
    }
    return opcion;
  }
}

export class FiltroApoyoComplementario implements IFiltro {
  constructor(
    public cvuSolicitante?: string | null,
    public estadosSolicitud?: EstadoSolicitud[] | null,
    public estadoSolucion?: null,
    public tipoSolucion?: TipoSolucion | null,
    public becaId?: string | null,
    public tags?: string[] | null
  ) {}
}
